import * as Yup from "yup";

const EditPortalUserFormValidation = Yup.object().shape({
 firstName: Yup.string().required("First name is required!"),
 lastName: Yup.string().required("Last name is required!"),
//  streetAddress:Yup.string().required("Address is required!"),
//  // email: Yup.string()
//  //     .email('Email ID is invalid!'),
//  primaryPhone: Yup.string()
//   .matches(
//    /\d{3}-\d{3}-\d{4}/,
//    // /\d?(\s?|-?|\+?|\.?)((\(\d{1,4}\))|(\d{1,3})|\s?)(\s?|-?|\.?)((\(\d{1,3}\))|(\d{1,3})|\s?)(\s?|-?|\.?)((\(\d{1,3}\))|(\d{1,3})|\s?)(\s?|-?|\.?)\d{3}(-|\.|\s)\d{4}/,
//    "Phone must contain 10 digits with following format 000-000-0000."
//   )
//   .required("Phone is required!"),
//  fax: Yup.string()
//   .matches(
//    /\d{3}-\d{3}-\d{4}/,
//    //  /\d?(\s?|-?|\+?|\.?)((\(\d{1,4}\))|(\d{1,3})|\s?)(\s?|-?|\.?)((\(\d{1,3}\))|(\d{1,3})|\s?)(\s?|-?|\.?)((\(\d{1,3}\))|(\d{1,3})|\s?)(\s?|-?|\.?)\d{3}(-|\.|\s)\d{4}/,
//    "Fax must contain 10 digits with following format 000-000-0000."
//   )
//   .required("Fax is required!"),
//  city: Yup.string().required("City is required!"),
//  zipCode: Yup.string()
//   .matches(/^[0-9]+$/, "Zip code must be numbers")
//   .min(5, "Length must equal to 5")
//   .max(5, "Length must equal to 5"),
//  state: Yup.string().required("State/Province is required!"),
//  npi: Yup.string()  .matches(
//   /^[0-9]{10}$/,
//   "NPI must be a 10-digit number"
// ).when("role", {
//     is: (role: any) => role === "Physician",
//     then: Yup.string().required("NPI is required!"),
//    }),
//  suffix: Yup.string().when("role", {
//   is: (role: any) => role === "Physician",
//   then: Yup.string().required("Suffix is required!"),
//  }),
//  specialty: Yup.string().when("role", {
//     is: (role: any) => role === "Physician",
//     then: Yup.string().required("Speciality is required!"),
//    }),
//  // organizations: Yup.string()
//  //        .required("Organizations are required!"),
});

export default EditPortalUserFormValidation;
